import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import Avatar from "react-avatar";
import "./InternalNotes.scss";
import { Mention, MentionsInput } from "react-mentions";
import { internalNotesModel } from "../../../models/InternalNotes";
import { formatDateOrDay, formatTimestamp } from "../../../utils/GeneralUtils";
import { mentionsUsers } from "../../../models/SharedModel";
import Service from "../../../services";
import { AxiosError } from "axios";
import { catchError } from "../../../utils/Utils";
import { BankUserContext } from "../../../bankUserContext";
import { ReactComponent as Like } from "../../../images/Like.svg";
import { ReactComponent as LikeActivated } from "../../../images/LikeActivated.svg";
import { useParams } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import RoleAuthorization from "../../Authentication/RoleAuthorization";
import { Pages, actionAuthorization } from "../../../utils/RolesUtil";
import mentionsInputStyle from "../../../commonfields/MentionsStyling/mentionsInputStyle";
import CommentMentions from "../../../commonfields/CommentMentions";
import { TriggerContext } from "../../../Context/TriggerContext";

interface internalNotesProps {
  Comment: internalNotesModel;
  usersData: mentionsUsers[];
  getInternalNotes: Function;
}

const InternalNotesComments = (props: internalNotesProps) => {
  const [Comment, setComment] = useState<internalNotesModel>(props?.Comment);
  const [showEditMode, setShowEditMode] = useState<boolean>(false);
  const [editingCommentValue, setEditingCommentValue] = useState(Comment?.comments || '');
  const [mentionsData, setMentionsData] = useState<any>(props?.Comment?.userIds);
  const [likeButton, setLikeButton] = useState<boolean>(Comment?.liked);
  const [likeButtonFunctionality, setLikeButtonFunctionality] = useState<boolean>(true);
  const service = new Service();
  const context = useContext(BankUserContext);
  const { clientProductsId } = useParams();
  const clientContext = useContext(TriggerContext);

  useEffect(() => {
    setComment(props?.Comment);
    setEditingCommentValue(props?.Comment?.comments)
    setLikeButton(props?.Comment?.liked)
  }, [props.Comment]);

  const editComment = () => {
    setShowEditMode(true);
    setEditingCommentValue(Comment?.comments);
  };

  const deleteComment = () => {
    const data = {
      "sections": "DeleteComment",
      "data": {
        "clientCommentId": Comment.clientCommentId
      }
    }

    service
      .deleteInternalNotes(data)
      .then(() => {
        toast.success("Comment deleted successfully")
        props.getInternalNotes();
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  const updateComment = () => {
    const data = {
      screen: "LandingPage",
      sections: "ClientComment",
      data: {
        clientCommentId: Comment?.clientCommentId,
        userIds: JSON.stringify(mentionsData),
        comments: editingCommentValue,
        clientProductId: clientProductsId,
        commentStatus: "Active",
        updatedBy: Comment?.updated_by,
        createdBy: Comment?.createdBy,
        updatedDate: new Date()
      },
    };
    service
      .saveInternalNotes(data)
      .then(() => {
        props.getInternalNotes();
        setShowEditMode(false);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  const cancelEditComment = () => {
    setShowEditMode(false);
    setEditingCommentValue(Comment?.comments);
  };

  const handleOnChange = (
    e: any,
    newValue: any,
    newPlainTextValue: any,
    mentions: any
  ) => {
    setEditingCommentValue(e.target.value);
  };

  const likeUpdate = (activated: boolean) => {
    let data = {};
    setLikeButton(!likeButton);
    setLikeButtonFunctionality(false)
    if (activated) {
      data = {
        screen: "LandingPage",
        sections: "ClientCommentEngagement",
        data: {
          userId: context?.bankuserDetails?.userId,
          clientCommentId: Comment?.clientCommentId,
          commentEngagementIdStatus: "Active",
          createdBy: context?.bankuserDetails?.userId,
        },
      };
      service
        .saveInternalNotes(data)
        .then(() => {
          props.getInternalNotes();
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        }).finally(() => {
          setLikeButtonFunctionality(true)
        });
    } else {
      data = {
        sections: "ClientCommentEngagement",
        data: {
          commentEngagementId: Comment?.commentEngagementId,
        },
      };
      service
        .deleteLike(data)
        .then(() => {
          props.getInternalNotes();
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        }).finally(() => {
          setLikeButtonFunctionality(true)
        });
    }
  };

  const addSuggestedUsers = (id: any) => {
    if (!mentionsData?.includes(id)) {
      setMentionsData([...mentionsData, id]);
    }
  };
  const onCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setEditingCommentValue(e.target.value);
  }

  return (
    <li className="commentslistContainer">
      <div className="commentssectionimagecontainer">
        <Avatar size="32px" round name={Comment?.firstName} />
      </div>
      <div className="commentslisttextContainer">
        <div className="commentSectionNameandTimeContainer">
          <p className="commentsectionnametext">{Comment?.firstName}</p>
          <p className="createddateTime">
            {Comment?.createdDate && Comment?.createdDate ? formatTimestamp(Comment?.createdDate) : '--'}
          </p>
        </div>
        {
          <>
            <div className="editCommentsSection">
              <CommentMentions
                placeholder="Add a Comment"
                value={editingCommentValue || ''}
                handleChange={onCommentChange}
                data={props.usersData}
                onAdd={addSuggestedUsers}
                disabled={!showEditMode}
                className={showEditMode ? "editSection" : "disabled"}
              />
            </div>
            {showEditMode ? (
              <>
                <div className="editformcontainer">
                  <button
                    type="button"
                    className="primary-btn"
                    onClick={() => updateComment()}
                    disabled={!editingCommentValue}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="secondary-btn"
                    onClick={() => cancelEditComment()}
                  >
                    Cancel
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="d-flex">

                  {context.bankuserDetails?.userId == Comment?.createdBy && (
                    <div className="deleteandeditconatiner">
                      {RoleAuthorization(Pages.customerDetailsPage, actionAuthorization.editInternalNotes) && !clientContext?.readOnlyMode && <><p
                        className="Commentsupdation"
                        onClick={() => editComment()}
                      >
                        Edit
                      </p>
                        <p className="Commentsupdation"> | </p></>}
                      {RoleAuthorization(Pages.customerDetailsPage, actionAuthorization.deleteInternalNotes) && !clientContext?.readOnlyMode && <p
                        className="Commentsupdation"
                        onClick={() => deleteComment()}
                      >
                        Delete
                      </p>}
                    </div>
                  )}
                  {!clientContext?.readOnlyMode && <div className="likeContainer">
                    {likeButton ? (
                      <LikeActivated
                        onClick={() => likeButtonFunctionality && likeUpdate(false)}
                        title=""
                      />
                    ) : (
                      <Like
                        onClick={() => likeButtonFunctionality && likeUpdate(true)}
                        className="likeButton"
                        title=""
                      />
                    )}
                    <p>{Comment?.like_count}</p>
                    {Comment?.likedUsers && <ul>
                      {Comment?.likedUsers?.map((m, index) => (
                        <li key={index}>{m?.likedUserName}</li>
                      ))}
                    </ul>}
                  </div>}
                </div>
              </>
            )}
          </>
        }
      </div>
    </li>
  );
};

export default InternalNotesComments;
